// extracted by mini-css-extract-plugin
export default {"BetaLabel":"StringField-module__BetaLabel__iiczber"};